var _style, _defs, _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessFunctions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 28",
    style: {
      enableBackground: "new 0 0 24 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:none;stroke:#3B3D40;stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.9,
    y: 4.6,
    width: 22.6,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,13.4v9.8c0,0.7,0.6,1.3,1.3,1.3h15.1c0.7,0,1.3-0.6,1.3-1.3v-9.8 M22.7,11c0,1.4-1.1,2.5-2.5,2.5 s-2.5-1.1-2.5-2.5 M17.7,11c0,1.4-1.2,2.5-2.7,2.5s-2.7-1.1-2.7-2.5 M12.3,11c0,1.4-1.2,2.5-2.7,2.5S6.8,12.4,6.8,11 M6.8,11 c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5 M12.3,5.1V11 M6.8,11l1.7-5.9 M16,5.1l1.7,5.9 M22.7,11H1.8l3-5.2 C5,5.4,5.4,5.1,5.9,5.1h12.8c0.5,0,0.9,0.2,1.1,0.6L22.7,11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,14.3v10.3 M15.5,19h-0.8 M6.3,19.8l3.1-3.2 M6.3,17.4l0.8-0.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 21.9,
    x2: 15.5,
    y2: 21.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFunctions);
export default __webpack_public_path__ + "static/media/business-functions.c50c0685.svg";
export { ForwardRef as ReactComponent };